import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { Building, BuildingLevel } from '../models/building';
import { ErrorService } from '../helpers/errorService';

interface RawBuildingOption {
  value: string | number;
  text?: string;
  html?: string;
}

@Injectable({ providedIn: 'root' })
export class BuildingService {
  constructor(private http: HttpClient, private errorService: ErrorService) {}

  list(): Observable<Building[]> {
    const url = environment.apiBaseUrl + endpoints.getAllBuildings;
    return this.http
      .get<RawBuildingOption[]>(url, { withCredentials: true })
      .pipe(
        map(rows =>
          rows
            .map(r => ({ id: Number(r.value), name: r.html || r.text || String(r.value) }))
            .filter(b => Number.isFinite(b.id))
            .sort((a, b) => a.name.localeCompare(b.name))
        ),
        catchError(this.errorService.handleError)
      );
  }

  getLevels(buildingId: number): Observable<BuildingLevel[]> {
    const url =
      environment.apiBaseUrl +
      endpoints.getLevelsForBuilding.replace(':buildingId', String(buildingId));
    return this.http
      .get<{ levels: BuildingLevel[] }>(url, { withCredentials: true })
      .pipe(
        map(res => res.levels || []),
        catchError(this.errorService.handleError)
      );
  }
}
